var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotMug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 41,
    viewBox: "0 0 34 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#DD353F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.575 0c-2.72 2.007 2.821 5.12 0 7.2M13.775 0c-2.72 2.007 2.821 5.12 0 7.2M20.175 0c-2.72 2.007 2.821 5.12 0 7.2M25.8 10.4H1v24.376C1 37.662 3.379 40 6.314 40h14.172c2.935 0 5.314-2.338 5.314-5.224V10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8 13.6h3.6c1.989 0 3.6 1.611 3.6 3.6v7.2c0 1.989-1.611 3.6-3.6 3.6h-3.6M8.2 10.4v8.8M4.2 21L6 19.2h3.6l1.8 1.8v5.4H4.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotMug);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNCIgaGVpZ2h0PSI0MSIgdmlld0JveD0iMCAwIDM0IDQxIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjREQzNTNGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxwYXRoIGQ9Ik02LjU3NSAwYy0yLjcyIDIuMDA3IDIuODIxIDUuMTIgMCA3LjJNMTMuNzc1IDBjLTIuNzIgMi4wMDcgMi44MjEgNS4xMiAwIDcuMk0yMC4xNzUgMGMtMi43MiAyLjAwNyAyLjgyMSA1LjEyIDAgNy4yTTI1LjggMTAuNEgxdjI0LjM3NkMxIDM3LjY2MiAzLjM3OSA0MCA2LjMxNCA0MGgxNC4xNzJjMi45MzUgMCA1LjMxNC0yLjMzOCA1LjMxNC01LjIyNFYxMC40eiIvPgogICAgICAgIDxwYXRoIGQ9Ik0yNS44IDEzLjZoMy42YzEuOTg5IDAgMy42IDEuNjExIDMuNiAzLjZ2Ny4yYzAgMS45ODktMS42MTEgMy42LTMuNiAzLjZoLTMuNk04LjIgMTAuNHY4LjhNNC4yIDIxTDYgMTkuMmgzLjZsMS44IDEuOHY1LjRINC4yeiIvPgogICAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };